import { axios } from '@Root/API'

export const edit = (contact_id, payload) => {
	return axios.put(`contact/${contact_id}/consent`, payload)
}
